import { FiberManualRecord } from '@mui/icons-material';
import { List, ListItem, ListItemButton, ListItemText, Typography, styled, useTheme } from '@mui/material';
import { BackdropImage } from '#components/BackdropImage/index.tsx';
import { SectionType } from '#enums/mediaTypes.ts';
import { formatReleaseDate } from '#helpers/formatReleaseDate.ts';
import { formatRuntime } from '#helpers/formatRuntime.ts';
import { type PartData } from './types.ts';

export type CollectionProps = {
  onPartClick: (part: string | number) => void;
  parts: PartData[];
  selectedPartId: string | number;
};

const Content = styled('div')();

export const Collection = ({ onPartClick, parts, selectedPartId }: CollectionProps) => {
  const theme = useTheme();

  return (
    <List
      sx={{
        color: theme.mainTextPrimary,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: 0,
        width: '100%',
      }}
    >
      {parts.map(({ id, releaseDate, runtime, src, status, subTitle, title }) => (
        <ListItem disablePadding key={id} sx={{}}>
          <ListItemButton
            disableRipple
            onClick={() => {
              onPartClick(id);
            }}
            sx={{
              ':active': {
                backgroundColor: '#181818',
              },
              alignItems: 'flex-start',
              backgroundColor: id === selectedPartId ? '#181818' : undefined,
              boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2)',
              padding: theme.spacing(2),
              width: '100%',
            }}
          >
            <BackdropImage
              id={id}
              src={src}
              sx={{
                [theme.breakpoints.up('sm')]: {
                  width: '230px',
                },
                flexShrink: 0,
                marginRight: theme.spacing(2),
                width: '150px',
              }}
              title={title}
              type={SectionType.Episode}
            />
            <Content>
              <ListItemText primary={title} />
              <Typography sx={{ color: theme.supportingTextPrimary, marginBottom: theme.spacing(0.5) }} variant="body2">
                {subTitle}
              </Typography>
              <div>
                <Typography sx={{ color: theme.supportingTextPrimary }} variant="body2">
                  <span>{releaseDate ? formatReleaseDate(releaseDate) : status}</span>
                  {runtime ? (
                    <FiberManualRecord
                      sx={{
                        height: '10px',
                        marginLeft: theme.spacing(1),
                        marginRight: theme.spacing(1),
                        width: '10px',
                      }}
                    />
                  ) : undefined}
                  {runtime ? <span>{formatRuntime(runtime)}</span> : undefined}
                </Typography>
              </div>
            </Content>
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};
